import { toJSDate } from './date';

export const ARTIST_AGE_FILTER_OPTIONS = [
  { id: 'all', label: 'All ages' },
  { id: '6-8', label: 'Ages 6–8' },
  { id: '9-11', label: 'Ages 9–11' },
  { id: '12+', label: 'Age 12+' },
];

/** Parse artist profile birthday (YYYY-MM-DD or other date shapes). */
export function parseArtistBirthday(birthday) {
  if (birthday == null || birthday === '') return null;
  if (typeof birthday === 'string') {
    const iso = birthday.trim();
    const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) {
      const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
      return Number.isNaN(d.getTime()) ? null : d;
    }
  }
  return toJSDate(birthday);
}

/** Whole years old today; null if birthday unknown or invalid. */
export function calculateArtistAge(birthday) {
  const birth = parseArtistBirthday(birthday);
  if (!birth) return null;

  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age -= 1;
  }
  return age >= 0 && age < 120 ? age : null;
}

/** Map age to filter bucket id, or null if outside 6–8 / 9–11 / 12+. */
export function getArtistAgeBand(age) {
  if (age == null || typeof age !== 'number') return null;
  if (age >= 6 && age <= 8) return '6-8';
  if (age >= 9 && age <= 11) return '9-11';
  if (age >= 12) return '12+';
  return null;
}

export function artistMatchesAgeFilter(artist, filterId) {
  if (!filterId || filterId === 'all') return true;
  const age = calculateArtistAge(artist?.birthday);
  if (age == null) return false;
  return getArtistAgeBand(age) === filterId;
}
